import React, { useState } from "react";
import api from "../lib/api";

export default function HandoffForm({ sessionId, language, prefillMessage, onSuccess, onCancel }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    message: prefillMessage || "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your name";
    const digits = (form.phone || "").replace(/\D/g, "").slice(-10);
    if (!/^[6-9]\d{9}$/.test(digits)) e.phone = "Enter a valid 10-digit Indian mobile";
    if (!form.message.trim()) e.message = "Please share a short note for the team";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    try {
      await api.submitHandoff({
        session_id: sessionId,
        name: form.name.trim(),
        phone: (form.phone || "").replace(/\D/g, "").slice(-10),
        message: form.message.trim(),
        language: language || "english",
      });
      onSuccess();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setErrors({ _form: typeof detail === "string" ? detail : "Could not submit — please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sd-form-card" data-testid="handoff-form">
      <div className="sd-form-title">Leave your details</div>
      <div className="sd-form-desc">
        Share your name, number and a short note — someone from the clinic will reply
        to you personally.
      </div>

      <div className="sd-form-row">
        <label className="sd-label">Your name</label>
        <input
          data-testid="handoff-name"
          className="sd-form-input"
          value={form.name}
          onChange={(e) => update("name", e.target.value)}
        />
        {errors.name && <div className="sd-form-error">{errors.name}</div>}
      </div>

      <div className="sd-form-row">
        <label className="sd-label">Mobile number</label>
        <input
          data-testid="handoff-phone"
          className="sd-form-input"
          value={form.phone}
          onChange={(e) => update("phone", e.target.value)}
          inputMode="tel"
          maxLength={15}
        />
        {errors.phone && <div className="sd-form-error">{errors.phone}</div>}
      </div>

      <div className="sd-form-row">
        <label className="sd-label">Your message</label>
        <textarea
          data-testid="handoff-message"
          className="sd-form-textarea"
          rows={3}
          value={form.message}
          onChange={(e) => update("message", e.target.value)}
        />
        {errors.message && <div className="sd-form-error">{errors.message}</div>}
      </div>

      {errors._form && <div className="sd-form-error" style={{ marginBottom: 8 }}>{errors._form}</div>}

      <div className="sd-form-actions">
        <button
          data-testid="handoff-submit"
          type="button"
          className="sd-btn-primary"
          onClick={submit}
          disabled={submitting}
        >
          {submitting ? "Sending…" : "Send to the team"}
        </button>
        <button
          data-testid="handoff-cancel"
          type="button"
          className="sd-btn-ghost"
          onClick={onCancel}
          disabled={submitting}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
